import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ShoppingCart = React.lazy(() => import('.'));

export const shoppingCartRoutes = [
  new Route({
    path: 'shopping-cart/:lastPage/:suffix?/:planName?',
    element: ShoppingCart,
    children: [],
  }),
];
